import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_38ectsymfw: FaireBrandEntity = {
  token: "b_38ectsymfw",
  type: "brand",
  name: "The Prairie Bakery Candle Kitchen LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/2b26868c6435003aeb98dab68eea1353c9272f8b8d777619cf47d6030d615c88.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/231e805aa90dab94551af1a7d85f012fb47268b3df4f2748110020492dbce7c4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2b26868c6435003aeb98dab68eea1353c9272f8b8d777619cf47d6030d615c88.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/231e805aa90dab94551af1a7d85f012fb47268b3df4f2748110020492dbce7c4.jpeg",
  location: "Verona, WI, USA",
  minimumOrderDollars: 96,
  rating: 4.9,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "We created The Prairie Bakery Candle Kitchen when we weren't finding the candles that we wanted in stores. Being a relatively creative and overly ambitious married couple, the solution seemed simple: make them ourselves! Once we started offering them to our friends and family, getting feedback, and making some adjustments, we knew we had a good product on our hands. We pay close attention to details, from the rustic jars and lids to the fun colors and accurate fragrances. We make candles that are atmospheric, set a mood, and create an experience for your customers. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:46.148Z",
    importedBy: "entity-db-cli",
  },
};
